import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { JsonContentEnum } from 'src/app/models/enums/json-content.enum';
import { formfnsimplerectificatif } from '../../../../shared/models/component-messages/formfnsimplerectificatif/formfnsimplerectificatif';
import { CanNavigateInStepperService } from '../../../../shared/services/can-navigate-in-stepper.service';
import { LogService } from '../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../shared/services/object-to-json-stepper-creator.service';
import { TypeAnn } from '../../../common/models/type.ann';
import { AnnonceurService } from '../../../common/services/annonceur/annonceur.service';
import { FormulaireServiceService } from '../../../services/formulaire-service.service';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
import { StepperBuilderService } from '../../../../avisDePub/creer/services/stepper.builder.service';
import { ContenuPdf } from '../../../common/models/contenuPdf';
import { SpinnerVisibilityService } from 'ng-http-loader';


@Component({
  selector: 'app-formfnsimple-rectificatif',
  templateUrl: './formfnsimple.component.html'
})
export class FormfnsimpleComponent implements OnInit {

  private LOG: LogService = new LogService(FormfnsimpleComponent);

  @Input() indexPage: any;
  @Input() disabled = true;
  @Input() linkForRouter: string;
  @Input() tableClass: string;
  @Input() formClass: string;
  @Input() form: FormGroup;
  @Input() referenceAvis: string;
  @Input() currentJson: any = new BehaviorSubject(null);
  public createForm = false;
  @Input() formName: string;
  @Input() diffBoamp = false;
  @Input() diffJoue = false;
  public ann = new TypeAnn();
  private isLierAvisSelected :boolean=false;

  public steps = [4, 6, 8, 9, 14, 18, 19];
  public pages: number[];

  public isFormValid = true;

  public simpRE = new formfnsimplerectificatif();

  constructor(
    private formulaireServiceService: FormulaireServiceService,
    public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
    private annonceurService: AnnonceurService,
    private canNavigateInStepperService: CanNavigateInStepperService,
    private avisDataTransferService:AvisDataTransferService,
    private stepperBuilderService: StepperBuilderService,
    private spinner: SpinnerVisibilityService
  ) { }


  public ngOnInit() {
    this.pages = Array.from({ length: 5 }, (_, index) => index + 1);
    this.initForm();
  }

  getUid(indexPage) {
    return '_STEP_ID_' + indexPage + '_SepSep_TypeAnn_SepSep_Rectificatif';
  }


  getUidCommon(indexPage) {
    return '_STEP_ID_' + indexPage + '_SepSep_Annonce_index_1_SepSep_TypeAnn';
  }

  getIntitule(indexPage) {
    return this.formulaireServiceService.hasTranslation(this.simpRE.step + indexPage) ? (this.simpRE.step + indexPage) : (this.simpRE.commonStep + indexPage)
  }

  getContents(indexPage) {
    switch (indexPage) {
      case this.steps[0]: return [];
      case this.steps[1]: return [];
      case this.steps[2]: return [];
      case this.steps[3]: return [];
      case this.steps[4]: return [];
      case this.steps[5]: return [];
      case this.steps[6]: return [];
    }
  }

  private initForm() {
    this.isLierAvisSelected=this.canNavigateInStepperService.isCreerAvisLierSelected;
    this.spinner.show();
    this.currentJson.subscribe(data => {
      if (data != null && typeof data != 'string' && !this.createForm) {
        this.ann = data.jsonSaisieFormulaire.ann;
        this.createForm = true;
        if (data.jsonSaisieFormulaire.stepId && this.indexPage>0.4)
          this.indexPage = data.jsonSaisieFormulaire.stepId;
        this.annonceurService.annonceurBhs.next(data.jsonSaisieFormulaire.annonceur);
        this.canNavigateInStepperService.isBOAMPorJOUE = null;
        this.canNavigateInStepperService.isSHALorPS = null;
        this.avisDataTransferService.setFormData(data);
        this.stepperBuilderService.prepareMapErrors(data.jsonFieldsErrorsWarnings);
        this.avisDataTransferService.jsonCSV = data.jsonCSV;
        this.avisDataTransferService.contenuPdf = data.jsonPdf;
        this.spinner.hide();
      } else {
        this.formulaireServiceService.getAvis(this.referenceAvis, FormsEnum.SIMP_RE, JsonContentEnum.EMPTY, data).subscribe(formData => {
          this.createForm = true;
          this.annonceurService.annonceurBhs.next(formData.jsonSaisieFormulaire.annonceur);
          this.ann = formData.jsonSaisieFormulaire.ann;
					const fluxAllerPA: any = formData.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos ? { ...formData.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos } : null;
					this.avisDataTransferService.sourceAppProfilAcheteurInfos = fluxAllerPA;
          this.avisDataTransferService.refConsultation=formData.refConsultation;
          this.avisDataTransferService.siret=formData.jsonSaisieFormulaire.ann.facturation.libelle.siret;
          this.avisDataTransferService.setFormData(formData);
          if (this.canNavigateInStepperService.isCreerAvisLierSelected && this.canNavigateInStepperService.isAvisLierNational && JSON.stringify(formData.jsonCSV).includes('{}')) {
            this.stepperBuilderService.prepareMapErrors(formData.jsonFieldsErrorsWarnings);
            this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_' + 1);
            this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_' + 2);
            this.stepperBuilderService.initFormLiePDF('assets/data/formPDF/lieForms/' + FormsEnum[FormsEnum.SIMP_RE] + '.json').subscribe(
              (json) => {
                this.avisDataTransferService.contenuPdf = new ContenuPdf();
                this.avisDataTransferService.contenuPdf.champs = json;
                this.stepperBuilderService.PDFAvisLiesSetted.next({json:json,formData:formData});
                return json;
              }
            );
          } else {
            this.stepperBuilderService.initDefaultMapErrors('assets/data/errors/' + FormsEnum[FormsEnum.SIMP_RE] + '.json');
            this.stepperBuilderService.initDefaultFormAD('assets/data/formAD/' + FormsEnum[FormsEnum.SIMP_RE] + '.json');
            this.stepperBuilderService.initDefaultFormPDF('assets/data/formPDF/' + FormsEnum[FormsEnum.SIMP_RE] + '.json');
          }
          this.spinner.hide();
        });
      }
    });
  }

  getIsCheckValid(indexPage) {
    return this.stepperBuilderService.getIsCheckValidate('_STEP_ID_' + indexPage);
  }
}
